import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { computed, defineAsyncComponent, ref } from 'vue'
import { accountApi } from '@services/account.service'
import { IS_COORDINATOR } from '@/modules/user/accessTokens'

import { isPermittedSimple } from '@/modules/user/permissions'
import { clearCookie, setCookie } from '@/utils/cookies'
import { COORDINATOR_ROLE_KEY, DOCTOR_ROLE_KEY, SELECTED_USER_ROLE_COOKIE_NAME } from '@/const'

import CoordinatorForm from './roles/Coordinator.vue'
import DoctorForm from './roles/Doctor.vue'
import { useModalOpener } from '@/composables/useModalOpener'


export default /*@__PURE__*/_defineComponent({
  __name: 'SignUpRole',
  props: {
  roles: Object,
  isChosenRole: Boolean,
  first_image: Object,
  second_image: Object,
},
  setup(__props, { expose: __expose }) {
  __expose();

const { t } = useI18n()

const RolesMap = {
  4800: {
    formComponent: CoordinatorForm,
    key: COORDINATOR_ROLE_KEY,
    subtitle: t("You have started registration as a coordinator"),
  },
  4900: {
    formComponent: DoctorForm,
    key: DOCTOR_ROLE_KEY,
    subtitle: t("You have started registration as a doctor"),
  },
}

const props = __props

const { index_url } = window

const img_map = {
  0: props.first_image,
  1: props.second_image,
}

const currentStep = ref(props.isChosenRole ? 1 : 0)


const steps = [t('Selecting a role on the portal'), t('Fill the form')]

const currentUserType = ref(
  props.isChosenRole
    ? isPermittedSimple([IS_COORDINATOR])
      ? 4800
      : 4900
    : 4800
)

function onChangeRole(role) {
  currentUserType.value = role
}
const isLoad = ref(false)

function confirmRole() {
  currentStep.value = 1
  setCookie(SELECTED_USER_ROLE_COOKIE_NAME, RolesMap[currentUserType.value].key)
}
function resetRoleSelection() {
  currentStep.value = 0
  clearCookie(SELECTED_USER_ROLE_COOKIE_NAME)
}

const __returned__ = { t, RolesMap, props, index_url, img_map, currentStep, steps, currentUserType, onChangeRole, isLoad, confirmRole, resetRoleSelection, get useI18n() { return useI18n }, computed, defineAsyncComponent, ref, get accountApi() { return accountApi }, get IS_COORDINATOR() { return IS_COORDINATOR }, get isPermittedSimple() { return isPermittedSimple }, get clearCookie() { return clearCookie }, get setCookie() { return setCookie }, get COORDINATOR_ROLE_KEY() { return COORDINATOR_ROLE_KEY }, get DOCTOR_ROLE_KEY() { return DOCTOR_ROLE_KEY }, get SELECTED_USER_ROLE_COOKIE_NAME() { return SELECTED_USER_ROLE_COOKIE_NAME }, CoordinatorForm, DoctorForm, get useModalOpener() { return useModalOpener } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})